import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { FloatLabelModule } from 'primeng/floatlabel';
import { ImageModule } from 'primeng/image';
import { InputTextModule } from 'primeng/inputtext';
import { StepperModule } from 'primeng/stepper';
import { TableModule } from 'primeng/table';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { DriverModel } from '../../../../model/driver.model';
import { DocumentVehicleModel } from '../../../../model/document.vehicle.model';
import { CheckboxModule } from 'primeng/checkbox';
import { AppService } from '../../../../core/service/app.service';
import { CoreApiService } from '../../../../core/service/core-api-service';
import { properties } from '../../../../../environments/properties';
import { RouterLink } from '@angular/router';
import { JsonRequest } from '../../../../model/jsonRequest.model';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { compressImage } from '../../../../shared/utils/image-compression.util';
import { isAllowedUploadType } from '../../../../shared/utils/file-type-validator.util';

@Component({
  selector: 'app-create-vehicle',
  standalone: true,
  imports: [
    StepperModule,
    ButtonModule,
    InputTextModule,
    ToggleButtonModule,
    CommonModule,
    FormsModule,
    FloatLabelModule,
    ReactiveFormsModule,
    TableModule,
    FileUploadModule,
    ImageModule,
    DropdownModule,
    CheckboxModule,
    RouterLink,
    IconFieldModule,
    InputIconModule,
  ],
  templateUrl: './create-vehicle.component.html',
  styleUrl: './create-vehicle.component.css',
})
export class CreateVehicleComponent implements OnInit {
  titulo: string = 'Crear Vehiculo';
  step1_titulo: string = 'Datos del Vehiculo';
  step2_titulo: string = 'Documentos';
  step3_titulo: string = 'Hecho';
  active: number = 0;

  selectDriver!: DriverModel;
  lstDriver!: DriverModel[];
  ltsDocument: DocumentVehicleModel[] = [];
  ltsTypeDocument: any[] = [];
  selectedTypeDocument: any | undefined;
  // veh_inspection: boolean = false

  formVehiculo = new FormGroup({
    veh_plate: new FormControl('', Validators.required),
    veh_num_registration: new FormControl('', Validators.required),
    veh_model: new FormControl('', Validators.required),
    veh_brand: new FormControl('', Validators.required),
    veh_quantity_person: new FormControl('', Validators.required),
    veh_anio: new FormControl('', Validators.required),
    veh_color: new FormControl('', Validators.required),
    veh_inspection: new FormControl('', Validators.required),
    veh_secure: new FormControl('', Validators.required),
    driver: new FormControl<DriverModel | null>(null),
  });

  constructor(
    private readonly apiService: CoreApiService,
    private readonly util: AppService,
  ) {}

  ngOnInit(): void {
    this.getLtsTypeDocument();
    this.getLstDriver();
  }

  getLtsTypeDocument(): void {
    const body: JsonRequest = {
      data: JSON.stringify({
        typ_type_document: 2,
      }),
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.apiService.consumirWSPost(
      properties.serviceGetAllTypeDocument,
      body,
      (data) => {
        this.ltsTypeDocument = data.data;
        this.selectedTypeDocument = this.ltsTypeDocument[0];
      },
    );
  }

  getLstDriver(): void {
    const body: JsonRequest = {
      data: '',
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.apiService.consumirWSPost(
      properties.serviceGetDriverSinAsignar,
      body,
      (data) => {
        this.lstDriver = data.data;
      },
    );
  }

  next(): void {
    this.active++;
  }
  back(): void {
    this.active--;
  }

  async onUploadAuto(files: File[], fileUpload: any) {
    if (!isAllowedUploadType(files[0], false)) {
      this.util.mostrarToast(
        'Crear Vehículo',
        'Formato no permitido. Solo se aceptan imágenes PNG o JPG.',
        4,
      );
      fileUpload.clear();
      return;
    }
    const doc = await compressImage(files[0]);
    const filestring = await this.previewFile(doc);
    this.ltsDocument.push({
      veh_doc_veh_id: 0,
      veh_doc_doc_id: 0,
      veh_doc_company: this.util.returnEmpresa(),
      veh_doc_typ_id: this.selectedTypeDocument.typ_id,
      file: doc,
      filstring: filestring,
      typeDocument: this.selectedTypeDocument,
    });
    fileUpload.clear();
  }

  remeveFile(index: number) {
    this.ltsDocument.splice(index, 1);
  }

  previewFile(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.result) {
          resolve(reader.result as string);
        } else {
          reject('Error al leer el archivo');
        }
      };
      reader.onerror = () => {
        console.log('Error al leer el archivo');
      };
    });
  }

  backStart() {
    this.active = 0;
  }

  createVehicle() {
    let documents = this.ltsDocument;
    const body: JsonRequest = {
      data: JSON.stringify({
        veh_plate: this.formVehiculo.get('veh_plate')?.value,
        veh_num_registration: this.formVehiculo.get('veh_num_registration')
          ?.value,
        veh_model: this.formVehiculo.get('veh_model')?.value,
        veh_brand: this.formVehiculo.get('veh_brand')?.value,
        veh_quantity_person: this.formVehiculo.get('veh_quantity_person')
          ?.value,
        veh_anio: this.formVehiculo.get('veh_anio')?.value,
        veh_color: this.formVehiculo.get('veh_color')?.value,
        veh_inspection:
          this.formVehiculo.get('veh_inspection')?.value == 'true' ? 1 : 0,
        veh_secure:
          this.formVehiculo.get('veh_secure')?.value == 'true' ? 1 : 0,
        veh_dri_id:
          this.formVehiculo.get('driver')?.value == null
            ? 0
            : this.formVehiculo.get('driver')?.value?.dri_id,
      }),
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };

    this.apiService.consumirWSPost(
      properties.serviceCreateVehicle,
      body,
      (data) => {
        if (data.estado === properties.codeOK) {
          const formData = new FormData();

          documents.forEach((doc, index) => {
            formData.append(
              `lista[${index}][veh_doc_veh_id]`,
              data.data.veh_id.toString(),
            );
            formData.append(
              `lista[${index}][veh_doc_company]`,
              this.util.returnEmpresa().toString(),
            );
            formData.append(
              `lista[${index}][veh_doc_typ_id]`,
              doc.veh_doc_typ_id.toString(),
            );
            formData.append(`lista[${index}].file`, doc.file, doc.file.name);
          });
          this.apiService.consumirWSFilePost(
            properties.serviceFilesVehicle,
            formData,
            (resp) => {
              this.next();
              this.util.mostrarToast(
                'Crear vehiculo',
                'Se ha creado el vehículo',
                1,
              );
            },
          );
          this.formVehiculo.reset();
          this.ltsDocument = [];
        } else {
          this.util.mostrarToast('Crear vehiculo', 'Error al crear', 4);
        }
      },
    );
  }
}
